export default "__VITE_ASSET__BansBdXw__"